import { MessageBarType } from "@fluentui/react";
import { useState } from "react";
import { IDataResult, IResult, ResponseStatus } from "../../common/models/Result";
import { useForm } from "../../common/viewmodels/DefaultVM";
import { Authentication } from "../../common/views/Authentication";
import { DataUtils } from "../../common/views/DataUtils";
import {
    AccountModel, AccountPhoneModel, EmailForgotPasswordModel, ForgotPasswordModel
} from "../models/AccountTypes";
import { AccountByService } from "../services/AccountService";
import { accountCallback } from "./LoginVM";

export function useForgotPasswordVM() {
    const [loading, setLoading] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const { form, setField, errorMessages, setErrorMessages,
        summaryText, setSummaryText, summaryType, setSummaryType
    } = useForm<ForgotPasswordModel>({
        isByEmail: false,
        countryCode: Authentication.getCountryCode() ?? "855",
        phoneNo: Authentication.getPhoneNo() ?? "",
        email: Authentication.getEmail() ?? "",
        telegram: false
    });

    const submit = (callback: accountCallback) => {
        getUser(callback);
    }

    const getUser = (callback: accountCallback) => {
        setLoading(true);
        const service = new AccountByService(form.isByEmail);
        const emailForm: EmailForgotPasswordModel = { email: form.email };
        const phoneForm: AccountPhoneModel = {
            countryCode: form.countryCode,
            phoneNo: form.phoneNo,
            telegram: false
        };

        const request = service.getUserForConfirm(form.isByEmail ? emailForm : phoneForm);

        DataUtils.onRequest(
            request,
            (result: IDataResult) => onUserResult(result, callback)
        );
    }

    const onUserResult = (result: IDataResult, callback: accountCallback) => {
        const account = result.data as AccountModel;

        if (result.status === ResponseStatus.success && account != null) {
            callback(account);
        } else {
            onFail(result);
        }

        setLoading(false);
    }

    const onFail = (result: IDataResult) => {
        const res = result as IResult
        if (res) {
            setErrorMessages(res.errorMessages);
            setSummaryText(res.summaryText ?? "");
            setSummaryType(res.summaryType ?? MessageBarType.info);
        }
    }

    return {
        form,
        setField,
        errorMessages,
        summaryText,
        summaryType,

        loading, setLoading,
        showConfirm, setShowConfirm,

        submit
    }
}